module.exports = __webpack_public_path__ + "img/1.4a50f3a4.png";